@if (question()?.questionText && !submitted() && !questionClosed()) {
<div class="feedback-container" [@slideAnimation]="animationType()">
  <button
    type="button"
    class="close btn btn-round close_btn"
    data-dismiss="modal"
    aria-label="Close"
    (click)="questionClosed.set(true)"
  >
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>

  <h2 class="font-weight-bold question">
    @if (writeEffectEnabled()) {
    <atx-type-writer
      [titles]="this.question()?.questionText"
      [writeDelay]="writeDelay()"
      (witterComplete)="questionTyped.set(true)"
    ></atx-type-writer>
    } @else {
    {{ question()?.questionText }}
    }
  </h2>

  @if (question()?.hasComment && answerSelected()) {
  <h4>
    @if (writeEffectEnabled()) {
    <atx-type-writer
      class="feedback-label"
      [titles]="commentLabel()"
      (witterComplete)="commentLabelTyped.set(true)"
    ></atx-type-writer>
    } @else {
    <span>{{ commentLabel() }}</span>
    }
  </h4>

  <textarea
    [formControl]="commentControl"
    [atxDisableControl]="submitted() || submitting()"
    class="form-control mt-1"
    maxlength="2000"
    id="message"
    placeholder="Enter your ideas and suggestions"
    i18n-placeholder="
      CBasket|Thank you page feedback commnet@@feedbackCommentPlaceholder"
  ></textarea>
  } @if (questionTyped() || !writeEffectEnabled()) {
  <div class="d-flex mt-2 align-items-center buttons_wrapper">
    @if (!answerSelected()) {
    <button
      class="btn btn-lg btn-primary ml-auto mr-2"
      (click)="answerQuestion(false)"
      i18n="CBasket|No button feedback@@noFeedbackBtnLabel"
    >
      No
    </button>
    <button
      class="btn btn-lg btn-success"
      (click)="answerQuestion(true)"
      i18n="CBasket|Yes button feedback@@yesFeedbackBtnLabel"
    >
      Yes
    </button>
    } @else if (commentLabelTyped() || !writeEffectEnabled()) {
    <button
      class="btn btn-success ml-auto"
      (click)="submitFeedback()"
      [disabled]="submitting()"
    >
      <span i18n="CBasket|Thank you submit button feedback@@submitFeedbackLabel"
        >Submit</span
      >
      <span class="arrows-animation">
        <fa-icon [icon]="['fas', 'angle-right']" class="ml-2"></fa-icon>
        <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
        <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
      </span>
    </button>
    }
  </div>
  }
</div>
}
